import { useEffect, useState } from "react"
import { AnswerField } from "./AnswerField"
import style from '../task-creator.module.css'
import {ru} from "../../../data/ru";
import {by} from "../../../data/by";
import TextArea from "./textArea";
export function Answers({typeId, changeAnswers,deleteAnswers,
                          defaultValue=[],changeTypeForEighth,changeTextAnswers, changePercent,changeParameterType2}) {
  let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdThree : by.RoleIdThree;

  const [answersFields, setAnswersFields] = useState(/** answerTypes[typeId] */[])
  const [type, setType] = useState(1)
  const [percent,setPercent]=useState(50)
  const [textAnswer,setTextAnswer]=useState('')
  const [isAllCheckAnswer,setIsAllCheckAnswer]=useState(false)
  const [valueSelect, setValueSelect]=useState(0)
  function onChangeSelect(e){
    setValueSelect(e.target.value)
  }
  function onChangeCheckBox(){
    setIsAllCheckAnswer(prev=>!prev)
  }
  function onChangeTextAnswers(e){
    setTextAnswer(e.target.value)
  }
  function onChangeType(value) { //тип полей для 8-го задания и 11-го
    setType(value)
  }

  useEffect(()=>{ //парарметры для выбора нескольких ответов
    const parameter = {
      isAllCheck:isAllCheckAnswer,
      maxCheckNumber:valueSelect
    }
    changeParameterType2(parameter)

  },[valueSelect,isAllCheckAnswer])

  useEffect(()=>{
  changeTypeForEighth(type)
},[type])

  useEffect(()=>{
    changeTextAnswers(textAnswer)
  },[textAnswer])
  useEffect(()=>{
    changePercent(percent)
  },[percent])

  useEffect(() => {
    if (typeId === '6' || typeId === '9' || typeId === '10') {
      setAnswersFields([<AnswerField key={0} id={0} change={changeAnswers} typeId={typeId}/>])
    }
    else {
      setAnswersFields([])
    }
    if(typeId === '8'){
      defaultValue.length>0?setType(defaultValue[0].type):setType(1)
    }
  }, [typeId])

  function addAnswerField() {
    setAnswersFields(prev => [...prev,
      <AnswerField typeId={typeId} key={prev.length} id={prev.length} change={changeAnswers}
                   deleteHandler={deleteAnswers}/>])
  }

  useEffect(() => {
    if(defaultValue.length>0) {
      if (typeId === '2') {
        setIsAllCheckAnswer(defaultValue?.[0]?.parameter?.isAllCheck||false)
        setValueSelect(+defaultValue?.[0]?.parameter?.maxCheckNumber||0)
      }
      if (typeId !== '6' && typeId !== '9' && typeId !== '10' && typeId !== '11') {
        defaultValue.forEach(answer => {
          setAnswersFields(prev => [...prev,
            <AnswerField defaultValue={answer} typeId={typeId} key={prev.length} id={prev.length} change={changeAnswers}
                         deleteHandler={deleteAnswers}/>])
        })
      } else if (typeId === '6' || typeId === '9' || typeId === '10') {
        setAnswersFields([<AnswerField defaultValue={defaultValue} key={0} id={0} change={changeAnswers}
                                       typeId={typeId}/>])
      } else if (typeId === '11') {
        if (answersFields.length === 0) {
          const defVal = [...defaultValue];
          const props = defVal.pop();
          setTextAnswer(props?.text || '');
          setPercent(props?.percent || 50);
          setType(props?.type || 1)
          defVal.forEach(answer => {
            setAnswersFields(prev => [
              ...prev,
              <AnswerField
                  defaultValue={answer}
                  typeId={typeId}
                  key={prev.length}
                  id={prev.length}
                  change={changeAnswers}
                  deleteHandler={deleteAnswers}
              />
            ]);
          });
        }
      }
    }
  }, [defaultValue])

  function onChangePercent(e) {
    setPercent(e.target.value)
  }

  const selectTypeAnswer =
      <div className={style.task_line_box}>
        <div className={style.task_type_eighth} onClick={e=>onChangeType(1)}>
          <input type="radio" value={1} checked={type===1} readOnly/>
          <h4>{language.choiceOfOneOption}</h4>
        </div>
        <div className={style.task_type_eighth} onClick={e=>onChangeType(2)}>
          <input type="radio" value={2} checked={type===2} readOnly />
          <h4>{language.multipleChoice}</h4>
        </div>
        <div className={style.task_type_eighth}>
          <input type="number" value={percent} onChange={e=>onChangePercent(e)}/>
          <h4>%</h4>
        </div>
      </div>

  const parType2=<div>
    <div>
      <input type={'checkbox'} onChange={()=>onChangeCheckBox()} checked={isAllCheckAnswer}/><label>Должны быть отмечены все верные ответы</label>
    </div>
   <div>
     <label>Сколько вопросов можно выбирать</label>
     <select   onChange={e=>onChangeSelect(e)} value={valueSelect}>
       <option value={answersFields.length}>Все</option>
       {answersFields.map((item,i)=><option value={i+1} key={i+1}>{i + 1}</option>)}
     </select>
   </div>
  </div>

  return (
      <div className={style.task_form_answers}>
        {(typeId === '8' || typeId==='11') && selectTypeAnswer}
        {typeId==='2' && parType2}
        {answersFields}
        {(typeId !== '6' && typeId !== '3' && typeId !== '9'&& typeId !== '10') &&
        <button className={style.task_answers_btn}
                onClick={() => addAnswerField()}>{language.createTaskButtonAddResponseOption}</button>}
        {typeId==='11'&&
        <div className={style.task_line_box}>
          <h4>{language.textAnswer}:</h4>
         <TextArea changeHandler={onChangeTextAnswers} value={textAnswer}/>

        </div>}
      </div>
  )
}